var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2152 40.1678L12.9057 41.9234C12.4581 44.4615 14.1529 46.8819 16.691 47.3294L41.8275 51.7616C44.3656 52.2092 46.786 50.5145 47.2336 47.9763L51.2623 25.1283C51.4773 23.9094 51.1992 22.6551 50.4894 21.6412C49.7795 20.6273 48.6959 19.9369 47.477 19.722L39.7179 18.3539",
    stroke: "var(--gray-40)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33366 5.16663H35.0003C36.2381 5.16629 37.4253 5.65785 38.3005 6.53309C39.1758 7.40833 39.6673 8.59551 39.667 9.83329V35.5C39.6673 36.7377 39.1758 37.9249 38.3005 38.8002C37.4253 39.6754 36.2381 40.167 35.0003 40.1666H9.33366C8.09588 40.167 6.90869 39.6754 6.03344 38.8002C5.1582 37.9249 4.66665 36.7377 4.66699 35.5V9.83329C4.66712 7.25602 6.75638 5.16676 9.33366 5.16663Z",
    stroke: "var(--gray-40)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.667 29.6667H4.66699",
    stroke: "var(--gray-40)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFiles);
export default __webpack_public_path__ + "static/media/upload-files.1fdf7c1389e67d88e74437aadf82e9cd.svg";
export { ForwardRef as ReactComponent };